<template>
  <div id="app">
    <transition :name="transitionName">
      <router-view v-wechat-title="$route.meta.title"></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      transitionName: ''
    }
  },
  watch: {
    $route (to, from) {
      // 监听路由变化时的状态为前进还是后退
      let isBack = this.$router.isBack
      if (isBack) {
        this.transitionName = 'slider-right'
      } else {
        this.transitionName = 'slider-left'
      }
      this.$router.isBack = false
    }
  }
}
</script>

<style lang="less">
/* 全局CSS */
@import url("./assets/css/app.less");
/* 切页动画 */
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
    will-change: transform;
    transition: all 250ms;
    position: absolute;
}
.slide-right-enter {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
}
.slide-right-leave-active {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
}
.slide-left-enter {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
}
.slide-left-leave-active {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
}
</style>



// WEBPACK FOOTER //
// src/App.vue